import { Button, makeStyles, Box } from "@material-ui/core";
import React from "react";
import { Link, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { addToCart } from "../../redux-store/shop/shop";
import { toast } from "react-toastify";
import { FaShoppingBasket } from "react-icons/fa";
import { Skeleton } from "@material-ui/lab";
import Swal from "sweetalert2";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "10px",
    border: `1px solid ${theme.palette.secondary.dark}`,
    textDecoration: "none",
    textAlign: "center",
    transition: "0.2s linear",
    "&:hover": {
      boxShadow: `0px 0px 15px 1px ${theme.palette.secondary.dark}`,
    },
  },
  coverImg: {
    width: "100%",
    height: 250,
    objectFit: "contain",
  },
  imgContainer: {
    width: "90%",
    margin: "0 auto",
  },
  bookTitle: {
    fontSize: "20px",
    fontWeight: 700,
    lineHeight: "24px",
    marginBottom: "10px",
  },
  price: {
    fontSize: "18px",
    fontWeight: "600",
    marginTop: "10px",
  },
  cartBtn: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.light,
    fontSize: "12px",
    fontWeight: "600",
    borderRadius: "2px",
    padding: "10px 0",
    width: "110px",
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.primary.main,
    },
  },
  toastBtn: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.light,
    textDecoration: "none",
    marginLeft: "20px",
  },
}));

function BookCard(props) {
  const { title, price, cover, bookId } = props;
  const state = useSelector((state) => state.shop);
  const { cart } = state;
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  //   const ToastBox = () => {
  //     return (
  //       <div>
  //         CART UPDATED
  //         <Link to="/cart" style={{ textDecoration: "none" }}>
  //           <Button
  //             variant="contained"
  //             className={classes.toastBtn}
  //             endIcon={<FaShoppingBasket />}
  //           >
  //             View Cart
  //           </Button>
  //         </Link>
  //       </div>
  //     );
  //   };

  const checkoutChoice = () => {
    Swal.fire({
      title: `Checkout Choice`,
      showCancelButton: true,
      showConfirmButton: true,
      cancelButtonText: "E-book",
      confirmButtonText: `Home Delivery`,
    }).then((value) => {
      if (value.isConfirmed) {
        history.push(
          `${process.env.PUBLIC_URL}/book/${bookId}/checkoutwithaddress`
        );
      }
      if (value.isDismissed) {
        history.push(`${process.env.PUBLIC_URL}/book/${bookId}/checkoutEbook`);
      }
    });
  };

  return (
    <div className={classes.root}>
      {cover && (
        
          <Box className={classes.imgContainer}>
            <img src={cover} className={classes.coverImg} />
          </Box>
      )}

      <h2 className={classes.bookTitle}>{title}</h2>
      <h3 className={classes.price}>${price}</h3>
      {/* {cart.find((item) => item.bookId===bookId)? <Link to="/cart" style={{textDecoration:'none'}}>View Cart</Link>: */}
      {/* // <Button className={classes.cartBtn} onClick={() => handleAddToCart(bookId, 1)}>ADD TO CART</Button> */}
      {/* <Link style={{ textDecoration: "none" }} to={`/book/${bookId}/checkout`}> */}
      <Link to={`/book/${bookId}`} style={{ textDecoration: "none" }}>
        <Button className={classes.cartBtn}>
          View Book
        </Button>
      </Link>
      {/* </Link> */}
      {/* // } */}
    </div>
  );
}

export default BookCard;
